import {
  FIRED_STATUSES,
  ROUTE_NAMES,
  ROUTE_PATHS,
} from '@/shared/constants';
import { defineNuxtMiddleware } from '@/types/nuxt2CompositionApiShims';
import type { User } from '@/types/User';

type FiredStatusUser = Partial<Pick<User, 'isFired' | 'agent_fire_status'>>;

export function getFiredRedirectPath (
  user: FiredStatusUser | undefined,
  routeName: string | null | undefined,
): string | undefined {
  if (user?.agent_fire_status?.status?.value === FIRED_STATUSES.await && routeName !== ROUTE_NAMES.profileRegistration) {
    return ROUTE_PATHS.profileRegistration;
  }

  if (user?.isFired && routeName !== ROUTE_NAMES.fired) {
    return ROUTE_PATHS.fired;
  }

  return undefined;
}

export default defineNuxtMiddleware(({
  route,
  store,
  redirect,
  $auth,
}) => {
  if (!$auth.loggedIn) {
    return;
  }

  const redirectPath = getFiredRedirectPath(store.state?.auth?.user, route.name);

  if (redirectPath) {
    return redirect(redirectPath);
  }
});
